import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

const toneClass = {
    safe: "ring-1 ring-emerald-500/15",
    info: "ring-1 ring-cyan-500/15",
    warning: "ring-1 ring-amber-500/15",
    critical: "ring-1 ring-rose-500/15",
    default: "",
};

const iconBg = {
    safe: "bg-emerald-500/10 text-emerald-300",
    info: "bg-cyan-500/10 text-cyan-300",
    warning: "bg-amber-500/10 text-amber-300",
    critical: "bg-rose-500/10 text-rose-300",
    default: "bg-muted text-muted-foreground",
};

export const KpiCard = ({
    title,
    value,
    icon: Icon,
    tone = "default",
    hint,
    loading = false,
    testId,
}) => (
    <Card
        className={cn("bg-card/60 backdrop-blur", toneClass[tone])}
        data-testid={testId || "kpi-card"}
    >
        <CardContent className="p-4 md:p-5">
            <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                    <p className="text-xs md:text-sm text-muted-foreground">
                        {title}
                    </p>
                    {loading ? (
                        <Skeleton className="mt-2 h-8 w-20" />
                    ) : (
                        <p
                            className="mt-1 text-2xl md:text-3xl font-semibold tabular-nums font-latin"
                            data-testid={"kpi-card-value"}
                            dir="ltr"
                        >
                            {value}
                        </p>
                    )}
                    {hint && (
                        <p className="mt-1 text-xs text-muted-foreground/80">
                            {hint}
                        </p>
                    )}
                </div>
                {Icon && (
                    <div
                        className={cn(
                            "inline-flex h-10 w-10 items-center justify-center rounded-lg",
                            iconBg[tone],
                        )}
                    >
                        <Icon className="h-5 w-5" />
                    </div>
                )}
            </div>
        </CardContent>
    </Card>
);

export default KpiCard;
